import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isRemote", "onEnter", "onExited"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { twMerge } from 'tailwind-merge';
import { jsx as _jsx } from "react/jsx-runtime";
export var CallTransition = function CallTransition(_ref) {
  var children = _ref.children,
    isRemote = _ref.isRemote,
    onEnter = _ref.onEnter,
    onExited = _ref.onExited,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(CSSTransition, _objectSpread(_objectSpread({
    classNames: "flex",
    timeout: {
      appear: 300,
      enter: 300,
      exit: 2000
    },
    onEnter: onEnter,
    onExited: onExited,
    isRemote: isRemote
  }, otherProps), {}, {
    children: children
  }));
};
export var MeetingTransition = function MeetingTransition(_ref2) {
  var children = _ref2.children,
    onExited = _ref2.onExited;
  return /*#__PURE__*/_jsx(CSSTransition, {
    classNames: "flex",
    timeout: {
      appear: 0,
      enter: 0,
      exit: 0
    },
    onExited: onExited,
    children: children
  });
};
var CSSTransitionTW = function CSSTransitionTW(_ref3) {
  var onEnter = _ref3.onEnter,
    onExited = _ref3.onExited,
    transitionIn = _ref3.transitionIn,
    children = _ref3.children,
    timeout = _ref3.timeout,
    unmountOnExit = _ref3.unmountOnExit,
    id = _ref3.id,
    className = _ref3.className;
  return /*#__PURE__*/_jsx(CSSTransition, {
    className: twMerge('flex', className),
    id: id,
    "in": transitionIn,
    timeout: timeout,
    onEnter: onEnter,
    onExited: onExited,
    unmountOnExit: unmountOnExit,
    children: children
  });
};
export var GenericCanvasTransition = function GenericCanvasTransition(_ref4) {
  var onEnter = _ref4.onEnter,
    onExited = _ref4.onExited,
    transitionIn = _ref4.transitionIn,
    children = _ref4.children,
    timeout = _ref4.timeout,
    unmountOnExit = _ref4.unmountOnExit;
  return /*#__PURE__*/_jsx(CSSTransition, {
    classNames: {
      enter: 'animate-slideInDialpad',
      exit: 'animate-slideOut'
    },
    "in": transitionIn,
    timeout: timeout,
    onEnter: onEnter,
    onExited: onExited,
    unmountOnExit: unmountOnExit,
    children: children
  });
};
export var DialpadTransition = function DialpadTransition(_ref5) {
  var onEnter = _ref5.onEnter,
    onExited = _ref5.onExited,
    transitionIn = _ref5.transitionIn,
    children = _ref5.children,
    timeout = _ref5.timeout,
    unmountOnExit = _ref5.unmountOnExit;
  return /*#__PURE__*/_jsx(CSSTransition, {
    classNames: {
      enter: 'animate-slideInDialpad',
      exit: 'animate-slideOut'
    },
    "in": transitionIn,
    timeout: timeout,
    onEnter: onEnter,
    onExited: onExited,
    unmountOnExit: unmountOnExit,
    children: children
  });
};
export default CSSTransitionTW;